export default __webpack_public_path__ + "static/media/Close.44d9ec88.svg";